import { FormProvider, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { useEffect, useMemo } from "react";
import { setCategory, setProviderFilter } from "redux/game/slice";
import ProviderFilter from "components/organisms/ProviderFilter";
import { GET_PARAMS } from "constants/popupConfig";
import {
  CATEGORIES_ENUMS,
  POPULAR_CATEGORIES,
} from "constants/navigation/categories";
import { useGTM } from "hooks/useGTM";
import { useBreakpoint } from "hooks/useBreakpoint";
import useQueryParam from "hooks/useQueryParam";
import * as gamesSelector from "redux/game/selectors";
import url from "url/index";
import { makeLangUrl } from "helpers/makeLangUrl";
import { useGetCategoriesList } from "../../queries/useGetCategoriesList";

const ProviderFilterContainer = () => {
  const dispatch = useDispatch();
  const GTM = useGTM();
  const providers = useSelector(gamesSelector.providers);
  const filter = useSelector(gamesSelector.filter);
  const methods = useForm();
  const navigate = useNavigate();
  const { isDesktop } = useBreakpoint();
  const category = useSelector(gamesSelector.category);
  const providersQuery = useQueryParam(GET_PARAMS.PROVIDERS);
  const selectedProviders = filter.providers;
  const gameUrl = useSelector(gamesSelector.gameUrl);

  const { categories, isLoading: categoriesLoading } = useGetCategoriesList(
    "mainPage",
    isDesktop ? 1 : 2,
  );
  const categoriesList = useMemo(() => {
    if (!categoriesLoading && categories.length) {
      return [categories[0], ...POPULAR_CATEGORIES, ...categories.slice(1)];
    }
    return POPULAR_CATEGORIES;
  }, [categoriesLoading, categories]);
  const currentCategory =
    categoriesList.find((cat) => cat.name === category) || null;

  useEffect(() => {
    if (!providersQuery) {
      methods.reset();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [providersQuery]);

  useEffect(() => {
    if (isDesktop && selectedProviders?.length && !gameUrl) {
      navigate(makeLangUrl(url.routes.casino.providers(selectedProviders)));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedProviders]);

  const handleProviderSelect = (name?: string) => {
    dispatch(setProviderFilter(name || null));
    if (!name) {
      selectedProviders?.forEach((provider) => {
        GTM.deleteProvidersFilterChoose(provider);
      });
      methods.reset();
      dispatch(setProviderFilter(""));
      if (isDesktop) {
        if (
          currentCategory &&
          currentCategory.name !== CATEGORIES_ENUMS.POPULAR
        ) {
          navigate(makeLangUrl(`/${currentCategory.name}`));
        } else {
          navigate(makeLangUrl(url.routes.casino.index()));
        }
      }
    } else {
      dispatch(setCategory(null));
      if (selectedProviders?.includes(name)) {
        GTM.deleteProvidersFilterChoose(name);
      } else {
        GTM.clickProvidersFilterChoose(name);
      }
    }
  };

  return (
    <FormProvider {...methods}>
      <ProviderFilter
        providers={providers}
        filter={filter}
        selectedProviders={selectedProviders}
        onProviderSelect={handleProviderSelect}
      />
    </FormProvider>
  );
};

export default ProviderFilterContainer;
